import React from 'react';
import { Eye, Crosshair } from 'lucide-react';
import { VIEW_MODES } from './hooks/useArchitectureVendorOverlay';
import './ViewModeToggle.css';

/**
 * ViewModeToggle - Toggle between Current State and Potential State views
 *
 * - Current State: Shows only nodes where vendor is already deployed
 * - Potential State: Shows all nodes where vendor has coverage (portfolio view)
 */
export default function ViewModeToggle({ viewMode, onSetViewMode, disabled = false }) {
  return (
    <div className={`vmt-container ${disabled ? 'vmt-container--disabled' : ''}`}>
      <button
        type="button"
        className={`vmt-btn ${viewMode === VIEW_MODES.CURRENT ? 'vmt-btn--active' : ''}`}
        onClick={() => onSetViewMode(VIEW_MODES.CURRENT)}
        disabled={disabled}
        title="Current State: Show only deployed products from selected vendors"
      >
        <Eye size={14} />
        <span>Current</span>
      </button>
      <button
        type="button"
        className={`vmt-btn ${viewMode === VIEW_MODES.POTENTIAL ? 'vmt-btn--active' : ''}`}
        onClick={() => onSetViewMode(VIEW_MODES.POTENTIAL)}
        disabled={disabled}
        title="Potential State: Show all products the vendor could cover"
      >
        <Crosshair size={14} />
        <span>Potential</span>
      </button>
    </div>
  );
}
